import { Button, Tooltip } from "antd"
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons"
import React from "react"
import { useIntl } from "react-intl"

type Props = {
  visible?: boolean
  onVisibilityChange?: (visible: boolean) => void
  disabled?: boolean
  target: string
}

export const VisibilityButton = ({ visible, onVisibilityChange, disabled, target }: Props) => {
  const intl = useIntl()

  return (
    <Tooltip
      placement="top"
      title={intl.formatMessage(
        { id: visible ? "common.hideTarget" : "common.showTarget" },
        { target: () => target }
      )}
    >
      <Button
        type="dashed"
        shape="circle"
        icon={visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
        onClick={() => onVisibilityChange?.(!visible)}
        disabled={disabled}
      />
    </Tooltip>
  )
}
